<template>
  <div>
    <div class="tw-w-full">
      <div class="itinerary-page-header">
        <ItineraryCard
          v-if="itinerary"
          class="tw-hidden lg:tw-block"
          :number-of-nights="itinerary.NumNights"
          :start-date="itinerary.StartDate"
          :end-date="itinerary.EndDate"
          :itinerary-logo="getItineraryImage"
          :start-price="itinerary.StartPrice"
          :uplift-price="itinerary.UpliftPrice"
          :price="itinerary.Price"
          :port-tax="itinerary.Tax"
          :ribbons="itinerary.Ribbons"
          :itinerary-name="itinerary.ItineraryName"
          :labels="labels"
          :is-uplift-enabled="isUpliftEnabled"
          @go-to-booking="goToBooking"
        ></ItineraryCard>
        <div
          class="
            back-button
            tw-flex tw-justify-end tw-mr-4 tw-my-2.5
            sm:tw-hidden
          "
        >
          <button
            class="
              tw-flex tw-justify-center tw-items-center
              searchResult_tabBackItinerary_mobile
            "
            @click="goBack"
          >
            <img
              class="tw-mr-2"
              :src="require('@/assets/icons/back-to-results.svg')"
            />
            <span class="tw-text-sm">{{ getBackToResultsMobileLabel }}</span>
          </button>
        </div>
      </div>
      <div class="itinerary-page-body">
        <div
          class="
            tw-flex tw-w-full tw-mt-4
            md:tw-justify-center
            tw-justify-between tw-px-4 tw-flex-nowrap
            md:tw-max-w-48r md:tw-mx-auto
            lg:tw-max-w-full
          "
        >
          <div
            v-for="tab in getTabs"
            :key="tab.id"
            @click="changeActiveTab(tab)"
            class="md:tw-mx-2.5 md-max-scr:tw-grow"
            :class="{
              'tw-hidden sm:tw-block sm:tw-ml-2 sm:tw-mr-0':
                tab.id === getTabs.length - 1,
              'xs:tw-mr-2': tab.id < getTabs.length - 2,
            }"
          >
            <itineraryTabsNavigationButton
              :label="tab.label"
              :is-active="activeTab === tab.id"
              :icon="tab.icon"
              :class="tab.trackingClass"
            />
          </div>
        </div>
        <CruiseInfo
          v-if="isDesktopLg"
          :data-cruise-info="dataCruiseInfo"
          class="tw-py-8"
        />
        <div
          v-if="itineraryDataAvailable"
          class="
            cruise-tab-wrapper
            tw-m-4 tw-px-0
            sm:tw-px-16
            lg:tw-px-0
            md:tw-max-w-48r
            lg:tw-max-w-56r
            xl:tw-max-w-63.5r
            2xl:tw-max-w-70.75r
            md:tw-mx-auto
          "
        >
          <div
            class="
              tw-grid
              lg:tw-grid-cols-4 lg:tw-mt-5 lg:tw-gap-x-4
              xl:tw-gap-x-5
            "
          >
            <CruiseSlider
              v-show="activeTab !== 2 && isDesktopLg"
              class="tw-col-span-1"
              :cruise-data="itinerary.Days"
              :slides-count="itinerary.Days && itinerary.Days.length"
              :slider-height="sliderHeight"
              :text-labels="labels"
              :active-cruise-index="activeCruiseIndex"
              @change-cruise-index="setActiveCruiseIndex"
            />
            <div
              :class="
                itineraryDataAvailable && activeTab !== 2
                  ? 'tw-col-span-4 lg:tw-col-span-3'
                  : 'tw-col-span-4'
              "
            >
              <ItineraryMapTab
                v-if="activeTab === 0"
                :active-cruise-index="activeCruiseIndex"
                :cruise-data="itinerary.Days"
                :is-desktop="isDesktopSm"
                :text-labels="labels"
                :style="{ height: isDesktopLg ? `${sliderHeight}px` : 'auto' }"
                @change-cruise-index="setActiveCruiseIndex"
              />
              <CruiseItineraryTab
                v-if="activeTab === 1"
                :cruise-data="itinerary.Days"
                :cruise-index="activeCruiseIndex"
                :text-labels="labels"
                :is-desktop-lg="isDesktopLg"
                :is-desktop-sm="isDesktopSm"
                :logo-mobile="getItineraryImageMobile"
                :logo-desktop="getItineraryImage"
                :cruise-description-tablet="cruiseDescriptionTablet"
              >
                <template slot="cruise-info">
                  <CruiseInfo :data-cruise-info="dataCruiseInfo" />
                </template>
              </CruiseItineraryTab>
              <ShipTab
                v-if="activeTab === 2"
                :ship="itinerary.Ship"
                :is-desktop="isDesktopLg"
                :is-tablet="isDesktopSm"
                :active-cruise-index="activeCruiseIndex"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="itinerary-page-footer">
        <ItineraryCardFooter
          v-if="!isDesktopLg"
          :labels="labels"
          :start-price="itinerary.StartPrice"
          :price="itinerary.Price"
          :is-uplift-enabled="isUpliftEnabled"
          :uplift-price="itinerary.UpliftPrice"
          @go-to-booking="goToBooking"
        />
      </div>
    </div>
    <Loader v-if="loader" />
  </div>
</template>

<script>
import itineraryTabsNavigationButton from "@/stories/Components/CruiseItineraryDetail/Elements/ItineraryTabsNavigationButton";
import ItineraryMapTab from "@/stories/Components/CruiseItineraryDetail/Elements/Tabs/Map/ItineraryMapTab";
import ShipTab from "@/stories/Components/CruiseItineraryDetail/Elements/Tabs/Ship/ShipTab";
import CruiseItineraryTab from "@/stories/Components/CruiseItineraryDetail/Elements/Tabs/CruiseItineraryTab/CruiseItineraryTab";
import ItineraryCard from "@/stories/Components/CruiseItineraryDetail/Elements/desktop/ItineraryCard/ItineraryCard";
import CruiseSlider from "@/stories/Components/CruiseItineraryDetail/Elements/desktop/CruiseSlider/CruiseSlider";
import ItineraryCardFooter from "@/stories/Components/CruiseItineraryDetail/Elements/mobile/ItineraryCardFooter";
import CruiseInfo from "@/stories/Components/CruiseItineraryDetail/Elements/CruiseInfo/CruiseInfo";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "root/tailwind.config.js";
import itineraryDataService from "./services/itineraryDataService";
import Loader from "@/stories/Atoms/Loader/Loader";

const fullConfig = resolveConfig(tailwindConfig);

export default {
  components: {
    itineraryTabsNavigationButton,
    ItineraryMapTab,
    ShipTab,
    CruiseItineraryTab,
    ItineraryCard,
    CruiseSlider,
    ItineraryCardFooter,
    CruiseInfo,
    Loader,
  },
  name: "ItineraryDetail",
  props: {
    itineraryEndpoint: {
      type: String,
      required: true,
      default: "",
    },
    labelsEndpoint: {
      type: String,
      required: true,
      default: "",
    },
    language: {
      type: String,
      required: false,
      default: "en-US",
    },
    defaultActiveTab: {
      type: Number,
      required: false,
      default: 1,
    },
    previewMode: {
      // bypasses Redis cache. Used on CM servers
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      cruiseId: "",
      itinerary: {},
      labels: {},
      activeTab: 1,
      windowWidth: window.innerWidth,
      scrollTop: 0,
      isUserScrollBottom: false,
      tabs: [
        {
          id: 0,
          description: "map",
          labelKeyDesktop: "cruiseModalTabsItineraryMapLabel",
          labelKeyMobile: "cruiseModalTabsItineraryMapLabelMobile",
          trackingClass: "searchResult_tabMapItinerary",
          label: "",
          icon: null,
          click: () => (this.activeTab = 0),
        },
        {
          id: 1,
          description: "itinerary",
          labelKeyDesktop: "cruiseModalTabsItineraryLabel",
          labelKeyMobile: "cruiseModalTabsItineraryLabelMobile",
          trackingClass: "searchResult_tabCruiseItinerary",
          label: "",
          icon: null,
          click: () => (this.activeTab = 1),
        },
        {
          id: 2,
          description: "ship",
          labelKeyDesktop: "cruiseModalTabsShipLabel",
          labelKeyMobile: "cruiseModalTabsShipLabelMobile",
          trackingClass: "searchResult_tabShipItinerary",
          label: "",
          icon: null,
          click: () => (this.activeTab = 2),
        },
        {
          id: 3,
          description: "close",
          labelKeyDesktop: "cruiseModalTabsGoBackLabel",
          labelKeyMobile: "cruiseModalTabsGoBackLabelMobile",
          trackingClass: "searchResult_tabBackItinerary",
          label: "",
          icon: "arrow-left.svg",
          click: () => this.goBack(),
        },
      ],
      itineraryDataAvailable: false,
      activeCruiseIndex: 0,
      bodyEl: null,
      headerEl: null,
      loader: false,
      fixHeaderClassList: ["tw-fixed", "tw-z-[20000]", "tw-top-0"],
      mscItinerary: null,
    };
  },
  computed: {
    isDesktopSm() {
      return (
        this.windowWidth >= parseInt(fullConfig?.theme?.screens?.sm || 640)
      );
    },
    isDesktopLg() {
      return (
        this.windowWidth >= parseInt(fullConfig?.theme?.screens?.lg || 1024)
      );
    },
    sliderHeight() {
      return this.windowWidth >=
        parseInt(fullConfig?.theme?.screens?.xl || 1280)
        ? 333
        : 303;
    },
    getItineraryImage() {
      return (
        this.itinerary?.Images?.Desktop ||
        require("@/assets/images/itinerary-logo.png")
      );
    },
    getItineraryImageMobile() {
      return (
        this.itinerary?.Images?.Mobile ||
        require("@/assets/images/itinerary-logo.png")
      );
    },
    cruiseDescriptionTablet() {
      return this.itinerary?.ItineraryDescription || "";
    },
    getBackToResultsMobileLabel() {
      return this.labels?.cruiseTabsLabelsMobile
        ?.cruiseModalTabsGoBackLabelMobile;
    },
    getTabs() {
      return this.tabs.reduce((acc, tab, index) => {
        if (Object.keys(this.labels).length) {
          tab.label = this.isDesktopLg
            ? this.labels?.cruiseTabsLabelsDesktop[tab.labelKeyDesktop]
            : this.labels?.cruiseTabsLabelsMobile[tab.labelKeyMobile];
        }

        // in case mobile resolution 2nd item goes to the first position (because of UX criteria)
        return !this.isDesktopLg && index === 1 ? [tab, ...acc] : [...acc, tab];
      }, []);
    },
    dataCruiseInfo() {
      const departurePort = {
        iconName: "map-pointer",
        name: this.labels.cruiseModalInfoDepartureLabel,
        details: this.itinerary.DeparturePort,
      };
      const arrivalPort = {
        iconName: "map-pointer",
        name: this.labels.cruiseModalInfoArrivalLabel,
        details: this.itinerary.ArrivalPort,
      };
      const ship = {
        iconName: "ship",
        name: "",
        details: this.itinerary.Ship?.ShipName,
      };
      const isRoundTrip = {
        iconName: this.itinerary.IsRoundTrip ? "refresh" : "rotate",
        name: "",
        details: this.itinerary.IsRoundTrip
          ? this.labels.cruiseModalInfoRoundTripLabel
          : this.labels.cruiseModalInfoOneWayLabel,
      };
      const numPorts = {
        iconName: "map-pointer",
        name: "",
        details: `${this.itinerary.NumPorts} ${this.labels.cruiseModalInfoPortsLabel}`,
      };
      const numSeaDays = {
        iconName: "sea-waves",
        name: "",
        details: `${this.itinerary.NumSeaDays} ${this.getSeaDaysLabel}`,
      };

      return [
        ...(this.isDesktopLg ? [departurePort, arrivalPort, ship] : []),
        isRoundTrip,
        numPorts,
        numSeaDays,
      ].map((el, index) => Object.assign(el, { id: index }));
    },
    getSeaDaysLabel() {
      return this.itinerary.NumSeaDays === 1
        ? this.labels?.cruiseModalInfoSeaDayLabel
        : this.labels?.cruiseModalInfoSeaDayLabelPlural;
    },
    isUpliftEnabled() {
      return Boolean(this.itinerary?.UpliftPrice);
    },
    getBookingUrl() {
      const { bookingParams } =
        JSON.parse(localStorage.getItem("itineraryData")) ?? {};
      const params = bookingParams ?? "";

      return `${window.location.protocol}//${window.location.hostname}/Booking?CruiseID=${this.cruiseId}${params}`;
    },
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const cruiseId = urlParams.get("cruiseId");
    this.cruiseId = cruiseId;

    this.activeTab = this.setDefaultTabValue(this.defaultActiveTab);
    this.getLabels();
    this.getItineraryData(cruiseId);

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });

    this.bodyEl = document.getElementById("outerContainer");
    this.headerEl = document.getElementById("msc-header");
  },
  methods: {
    goToBooking() {
      window.location.href = this.getBookingUrl;
    },
    fixOuterPage() {
      this.bodyEl.classList.add("tw-overflow-hidden");
      this.headerEl.classList.add(...this.fixHeaderClassList);
    },
    unFixOuterPage() {
      this.bodyEl.classList.remove("tw-overflow-hidden");
      this.headerEl.classList.remove(...this.fixHeaderClassList);
    },
    getMenuTopIndent() {
      if (this.headerEl) {
        return this.headerEl.offsetHeight;
      }
    },
    goHome() {
      return (window.location.href = "/");
    },
    getLocalData() {
      let localData = localStorage.getItem("itineraryData");

      if (!localData) {
        return {
          cruiseId: "",
          cruiseTitle: "",
          fallbackImageMobile: "",
          fallbackImageDesktop: "",
          portTax: 0,
          price: 0,
          ribbons: [],
          upliftPrice: 0,
          currentSearchQuery: "",
        };
      }

      const itineraryData = JSON.parse(localData);

      return itineraryData;
    },
    async getItineraryData(cruiseId) {
      this.loader = true;
      let endpoint = this.itineraryEndpoint;
      if (cruiseId) {
        endpoint = `${endpoint}/${cruiseId}?lang=${this.language}`;
      }

      const localData = this.getLocalData();

      if (cruiseId !== localData.cruiseId) this.goHome();

      try {
        this.itinerary = await itineraryDataService.getItineraryData(
          endpoint,
          this.previewMode,
          localData
        );

        this.itineraryDataAvailable = true;
        this.activeTab = this.defaultActiveTab;
      } catch (e) {
        console.error(e);
      } finally {
        this.loader = false;
      }
    },
    async getLabels() {
      try {
        this.labels = await itineraryDataService.getLangData(
          this.labelsEndpoint,
          this.language,
          this.previewMode
        );
      } catch (e) {
        console.error(e);
      }
    },
    changeActiveTab(tab) {
      if (tab.id === this.tabs[this.tabs.length - 1].id) {
        this.goBack();
        this.activeTab = 1;
      }
      this.activeTab = tab.id;
    },
    goBack() {
      const localData = this.getLocalData();
      window.location.href = localData.currentSearchQuery;
    },
    setActiveCruiseIndex(activeCruiseIndex) {
      this.activeCruiseIndex = activeCruiseIndex;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    setDefaultTabValue(value) {
      return typeof value === "undefined" ||
        !this.tabs[value] ||
        this.tabs[value].description === "close"
        ? 1
        : value;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    localStorage.removeItem("itineraryData");
  },
};
</script>

<style lang="scss" scoped>
@import "ItineraryDetail.scss";
</style>
